import apiCompetitiveActivity from '@/api/competitive-activity'

const state = {
  data: [],
  isLoading: false,
  validationErrors: null,
}

export const mutationTypes = {
  getCompetitiveActivityStart:
    '[competitive activity kind sport] getCompetitiveActivity kind sport Start',
  getCompetitiveActivitySuccess:
    '[competitive activity kind sport] getCompetitiveActivity kind sport Success',
  getCompetitiveActivityFailure:
    '[competitive activity kind sport] getCompetitiveActivity kind sport Failure',
}

export const actionType = {
  getCompetitiveActivity:
    '[competitive activity kind sport] getCompetitiveActivity kind sport',
}

const mutations = {
  [mutationTypes.getCompetitiveActivityStart](state) {
    state.isLoading = true
    state.validationErrors = null
    state.data = []
  },

  [mutationTypes.getCompetitiveActivitySuccess](state, payload) {
    state.isLoading = false
    state.data = payload
  },

  [mutationTypes.getCompetitiveActivityFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionType.getCompetitiveActivity](context, params) {
    context.commit(mutationTypes.getCompetitiveActivityStart)
    return new Promise((resolve) => {
      apiCompetitiveActivity
        .getCompetitiveActivityKindSport(params)
        .then((response) => {
          context.commit(
            mutationTypes.getCompetitiveActivitySuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getCompetitiveActivityFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
